import React from 'react';
import './styles/AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <h1 className="page-title font-serif">About Us</h1>
        <p className="page-subtitle">Get to know the team at Maple Nook.</p>
      </div>

      <div className="about-content">
        <section className="about-section">
          <h2 className="section-heading font-serif">Our Story</h2>
          <p className="section-text">
            Welcome to Maple Nook! We are a husband and wife team who decided to turn our hobbies 
            into something just a little bit more.
          </p>
          <p className="section-text">
            Everything we list here at Maple Nook was handmade and personal. These are items we wanted to make,
            and were done so in our leisure time. As a result, each item has a story for us. We hope you'll 
            make your own cozy memories with our creations!
          </p>
        </section>

        <section className="about-section">
          <h2 className="section-heading font-serif">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🌿</div>
              <h3 className="value-title">Sustainability</h3>
              <p className="value-description">
                While we are always experimenting with new materials and sources, we prefer to avoid
                materials obtained from questionable sources such as Temu, Shein etc.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤲</div>
              <h3 className="value-title">Craftsmanship</h3>
              <p className="value-description">
                Every item is hand made. While this does mean from time to time things will not be perfect,
                we believe there is a lot of charm and personality to this approach.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">💚</div>
              <h3 className="value-title">Care</h3>
              <p className="value-description">
                We craft things inspired by what we care about, and we hope that care shines through.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🥳</div>
              <h3 className="value-title">Fun</h3>
              <p className="value-description">
                We have fun making our products, and we hope you'll have fun with them too!
              </p>
            </div>
          </div>
        </section>  
      </div>
    </div>
  );
};

export default AboutPage;